import Link from 'next/link';
import type {IconComponentProps} from '@web3icons/react';

import CSS from './Coin.module.scss';
import CoinIcon from './CoinIcon';
import {resolveRoute} from '@/lib/routes';
import type {Coin} from '@/types/api/prices';

export default function Coin({
  id,
  name,
  iconSize,
  isNetwork,
  isLink,
  acronymInFront,
  acronymSmallGap,
  className
}: {
  /** The token abbreviation. */
  id: Coin['id'];
  /** The token full name. */
  name?: Coin['fa'];
  iconSize?: IconComponentProps['size'];
  isNetwork?: boolean;
  isLink?: boolean;
  acronymInFront?: boolean;
  acronymSmallGap?: boolean;
  className?: HTMLDivElement['className'];
}) {
  const size = iconSize || '2.5rem';
  const hasName = !!name;

  return (
    <div
      className={[CSS.coin, hasName ? CSS.fullName : '', className || ''].join(
        ' '
      )}
      style={{'--svg-size': size} as React.CSSProperties}>
      <CoinIcon
        className={CSS.icon}
        symbol={isNetwork ? undefined : id}
        network={isNetwork ? id : undefined}
        networkName={isNetwork ? name : undefined}
        size={size}
      />

      {hasName && (
        <div className={CSS.name} title={name}>
          {isLink && !isNetwork ? (
            <Link href={resolveRoute('base.markets.coin', {coin: id})}>
              {name}
            </Link>
          ) : (
            name
          )}
        </div>
      )}

      <div
        className={[
          CSS.acronym,
          acronymInFront ? CSS.inFront : '',
          acronymSmallGap ? CSS.smallGap : ''
        ].join(' ')}>
        {id.toUpperCase()}
      </div>
    </div>
  );
}
